import type { RootSearch } from '@/routes/__root'

export type Platform = 'gallery' | 'upptacka' | 'web'
export function getPlatform(search: RootSearch): Platform {
  if (search.origin) return 'upptacka'
  if (search.ipexGallery) return 'gallery'
  return 'web'
}
